























































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from "vue";
import eventBus from "@/services/eventBus";
import IconButton from "@/components/IconButton.vue";
import FormSection from "@/components/FormSection.vue";
import ConfirmationBox from "@/components/ConfirmationBox.vue";
import PreAccHeadEdit from "../components/PreAccHeadEdit.vue";
import PreAccItemEdit from "../components/PreAccItemEdit.vue";
import PreAccItemDimensionEdit from "../components/PreAccItemDimensionEdit.vue";
import store, { PreAccountingStore } from "../services/PreAccountingStore";
import PreAccountingApi from "../services/PreAccountingApi";
import {
  PreAccEditDimension,
  PreAccEditDimensionDefaultProps,
  PreAccEditItem,
  PreAccEditItemDefaultProps,
  PreAccInvoiceDoc,
  PreAccInvoiceInfo,
  PreAccVatDateInfo,
} from "../models/PreAccEditing";
import { PreAccError, PreAccItemLog, PreAccStatusLog } from "../models/PreAccounting";
import GeneralIngoingInvoiceApi from "@/modules/generalIngoingInvoice/services/GeneralIngoingInvoiceApi";
import ValidationError from "@/modules/downPayment/components/ValidationError.vue";
import { t } from "@/plugins/i18n";

interface Data {
  store: PreAccountingStore;
  isMultiTableView: boolean;
  accDateMenu: boolean;
  accDateValue: string;
  // MIX könyvelési dátum újragenerálás (K2D pb_acc_date)
  mixAccDateMenu: boolean;
  mixAccDateValue: string;
  isRegeneratingMix: boolean;
  // KÉK utókalkulációs ár újraszámolás (K2D pb_postcalc_price) + a "már módosítva" kérdés
  isRecalcPostcalc: boolean;
  postcalcConfirmVisible: boolean;
  postcalcConfirmMessage: string;
  // K2D id_acc_date: a számla kontír-dátuma — a tömeges csere után az új sorok is ezt kapják
  bulkAccDate: string;
  // Feladás a belső főkönyvbe (K2D pb_felad)
  isPosting: boolean;
  postConfirmVisible: boolean;
  postConfirmMessage: string;
  // Az aktuális számla kontírozási hibái (K2D pb_hiba + a mentés/feladás utáni
  // automatikus w_popup_inv_err) — mindkettő a fejléc ⚠ menüjét használja
  errorMenu: boolean;
  invoiceErrors: PreAccError[];
  // Automatikus kontírozás (K2D pb_cont)
  isReAccounting: boolean;
  reAccountConfirmVisible: boolean;
  // A költséghely-bontás mentése utáni újrakontírozás-kérdés (K2D dw_1::buttonclicked)
  splitReAccountConfirmVisible: boolean;
  // Megjegyzés-szerkesztő (K2D pb_note + w_note_cont)
  noteMenu: boolean;
  noteText: string;
  noteItem: PreAccEditItem | null;
  isSavingNote: boolean;
  // Információs adatlapok (K2D pb_info + pb_info2)
  prefixInfoMenu: boolean;
  generalInfoMenu: boolean;
  // Napló menü (K2D m_naplo_accinv): tétel-napló + státusznapló
  logMenu: boolean;
  logView: string;
  itemLogs: PreAccItemLog[];
  statusLogs: PreAccStatusLog[];
  logsLoaded: boolean;
  isLogsLoading: boolean;
  // ÁFA dátum (K2D w_popup_vat_date_os) + projekt-kapcsolat
  roundDiffMenu: boolean;
  roundDiffs: any[];
  roundDiffsLoaded: boolean;
  isRoundDiffsLoading: boolean;
  vatDateMenu: boolean;
  vatDateValue: string;
  isSavingVatDate: boolean;
  vatDateInfo: PreAccVatDateInfo | null;
  isVatDateInfoLoading: boolean;
  vatDateConfirmVisible: boolean;
  vatDateConfirmMessage: string;
  vatDateReAccountConfirmVisible: boolean;
  projectMenu: boolean;
  projectName: string;
  projectLoaded: boolean;
  isProjectLoading: boolean;

  infoLoaded: boolean;
  info: PreAccInvoiceInfo;

}

interface Methods {
  loadCurrent(): Promise<void>;
  loadErrors(): Promise<void>;
  goTo(index: number): void;
  switchTableView(): void;
  undoChanges(): void;
  addNewItem(side: string): void;
  copyItemFromSelected(item: PreAccEditItem): void;
  // copyItemFromSelectedWithDimensions(item: PreAccEditItem): void;
  removeItem(item: PreAccEditItem): void;
  addNewDimension(side: string): void;
  removeDimension(dim: PreAccEditDimension): void;
  // copyDimensionFromSelected(side: string): void;   — kivéve (ld. a template kommentjét)
  // hasSameItem(dim: PreAccEditDimension, targetItem: PreAccEditItem): boolean;
  onNoteEdit(item: PreAccEditItem): void;
  onRegister(refs: any[]): void;
  columnReorder(columns: any[]): void;
  selectFirstItem(): void;
  onKeydown(e: KeyboardEvent): void;
  cloneItem(source: PreAccEditItem, sign: string): PreAccEditItem;
  formatMoney(value: number): string;
  applyAccDate(): void;
  applyMixAccDate(): Promise<void>;
  recalcPostcalcPrice(confirmed: boolean): Promise<void>;
  postToLedger(confirmed: boolean): Promise<void>;
  firstEditError(): { message: string; item: PreAccEditItem | null };
  validateItems(): string;
  save(): Promise<void>;
  startReAccount(): void;
  onAccGroupSplitSaved(): void;
  doReAccount(): Promise<void>;
  openNoteEditor(item: PreAccEditItem | null): void;
  saveNote(): Promise<void>;
  loadInfo(): Promise<void>;
  loadLogs(): Promise<void>;
  applyVatDate(confirmClosedPeriod: boolean): Promise<void>;
  loadVatDateInfo(): Promise<void>;
  loadRoundDiffs(): Promise<void>;
  formatRoundDiff(value: number): string;
  loadProject(): Promise<void>;
  openProjectsPage(): void;
  documentUrl(doc: PreAccInvoiceDoc): string;
  logFieldLabel(field: string): string;
}

interface Computed {
  isMix: boolean;
  mixItemsLocked: boolean;
  returnPath: string;
  isGeni: boolean;
  projectButtonVisible: boolean;
  roundDiffSum: number;
  mixAccDateVisible: boolean;
  mixAccDateDisabledReason: string;
  postcalcPriceVisible: boolean;
  pageTitle: string;
  itemColumns: any[];
  bothColumns: any[];
  dimSectionVisible: boolean;
  balanceRows: any[];
  balanceColumns: any[];
  todayString: string;
  postVisible: boolean;
  postDisabled: boolean;
  postTitle: string;
  validationError: string;
  saveDisabled: boolean;
  saveTitle: string;
  reAccountVisible: boolean;
  reAccountDisabled: boolean;
  reAccountTitle: string;
  noteVisible: boolean;
  infoVisible: boolean;
  generalFieldsLeft: any[];
  generalFieldsRight: any[];
  // A dimenzió-másoló nyilakkal együtt kivéve:
  // isInSameDimension: boolean;
  // isDisabledToNegative: boolean;
  // isDisabledToPositive: boolean;
}

export default Vue.extend<Data, Methods, Computed, {}>({
  components: {
    IconButton,
    FormSection,
    ConfirmationBox,
    PreAccHeadEdit,
    PreAccItemEdit,
    PreAccItemDimensionEdit,
    ValidationError,
  },

  data() {
    return {
      store,
      // K2D-hez hasonlóan T | K két táblával indulunk
      isMultiTableView: true,
      accDateMenu: false,
      accDateValue: "",
      mixAccDateMenu: false,
      mixAccDateValue: "",
      isRegeneratingMix: false,
      isRecalcPostcalc: false,
      postcalcConfirmVisible: false,
      postcalcConfirmMessage: "",
      bulkAccDate: "",
      isPosting: false,
      postConfirmVisible: false,
      postConfirmMessage: "",
      errorMenu: false,
      invoiceErrors: [] as PreAccError[],
      isReAccounting: false,
      reAccountConfirmVisible: false,
      splitReAccountConfirmVisible: false,
      noteMenu: false,
      noteText: "",
      noteItem: null as PreAccEditItem | null,
      isSavingNote: false,
      prefixInfoMenu: false,
      logMenu: false,
      logView: "items",
      itemLogs: [] as PreAccItemLog[],
      statusLogs: [] as PreAccStatusLog[],
      logsLoaded: false,
      isLogsLoading: false,
      roundDiffMenu: false,
      roundDiffs: [] as any[],
      roundDiffsLoaded: false,
      isRoundDiffsLoading: false,
      vatDateMenu: false,
      vatDateValue: "",
      isSavingVatDate: false,
      vatDateInfo: null,
      isVatDateInfoLoading: false,
      vatDateConfirmVisible: false,
      vatDateConfirmMessage: "",
      vatDateReAccountConfirmVisible: false,
      projectMenu: false,
      projectName: "",
      projectLoaded: false,
      isProjectLoading: false,

      generalInfoMenu: false,
      infoLoaded: false,
      info: { prefixTitle: "", prefixFields: [], generalFields: [], documents: [] } as PreAccInvoiceInfo,
    };
  },

  async mounted() {
    // Új MIX felvitel (K2D w_response_mix pb_insert): üres, írható fej, nincs bizonylat-lista
    if (this.$route.name === "PreAccCreate") {
      this.store.invoiceRefs = [];
      this.store.currentIndex = 0;
      try {
        await this.store.loadCreateData();
      } catch {
        // A lookupok nélkül is megnyílik az üres felvitel; a választólistákhoz
        // az új create-data végpontot futtató backend kell
        this.store.initCreateDefaults();
        eventBus.$emit("warn", t("PreAccounting_AValasztolistakNemToltodtekBeBackend"));
      }
      this.store.isReadOnlyView = false;
    } else {
      // Egy számlás mód: a route paraméterei adják a számlát; több számlás módban
      // a böngésző már feltöltötte a store.invoiceRefs listát (K2D ue_response_open)
      const prefix = this.$route.params.prefix;
      const invNo = Number(this.$route.params.invNo);
      if (prefix && invNo) {
        this.store.invoiceRefs = [{ code: prefix, invNo }];
        this.store.currentIndex = 0;
      }
      if (this.store.invoiceRefs.length === 0) {
        this.$router.push(this.returnPath);
        return;
      }
      await this.loadCurrent();
    }
    // A dim-választók törzsadatai egyszer töltődnek a szerkesztő életére
    if (this.store.serCars.length === 0) {
      this.store.loadDimLookups().catch(() => {
        eventBus.$emit("warn", t("PreAccounting_ADimenzioValasztokTorzsadataiNemToltodtek"));
      });
    }
    window.addEventListener("keydown", this.onKeydown);
  },

  beforeDestroy() {
    window.removeEventListener("keydown", this.onKeydown);
  },

  // Kilépés a szerkesztőből: a mentetlen módosítások kérdés nélkül elvesznek (TF-en
  // egységesen így, a K2D pb_exit-tiltása nélkül). A singleton store deltáit itt
  // nullázzuk, hogy a következő megnyitás tisztán induljon. Új MIX felvitelnél a mentés
  // utáni edit-re ugrás is ezen megy át, ott nincs eldobandó delta.
  beforeRouteLeave(to: any, from: any, next: any) {
    if (!this.store.isCreateMode) this.store.discardChanges();
    next();
  },

  computed: {
    // A böngésző, ahová a Mégse (és a hibás/üres nyitás) visszavisz. A számla
    // előkontírozás böngészője az alapértelmezés; a be/kitárolás böngésző a
    // ?returnTo= paraméterben adja át a saját útját (K2D: a w_response_mix a hívó
    // ablakra tér vissza). Csak app-on belüli, abszolút útvonalat fogadunk el.
    returnPath() {
      const raw = this.$route.query.returnTo;
      const value = Array.isArray(raw) ? raw[0] : raw;
      if (typeof value === "string" && value.startsWith("/") && !value.startsWith("//")) {
        return value;
      }
      return "/pre-accounting";
    },

    // MIX (vegyes) gyűjtőbizonylat — a K2D ezt SAJÁT ablakban (w_response_mix) kezeli,
    // ezért a számlás fej-elemek egy része itt nem értelmezett
    isMix() {
      return this.store.head.code === "MIX" || this.store.head.isMix === true;
    },

    // K2D w_response_mix: meglévő MIX bizonylaton (ii_oper = 7) a tétel-felvétel és
    // -törlés gombok tiltottak, csak a meglévő tételek módosíthatók
    mixItemsLocked() {
      return this.isMix && !this.store.isCreateMode;
    },

    // K2D ue_acc_date: a gomb kapuja a típus is_acc_date_mod flagje. Nálunk emellett
    // mentett bizonylat kell (a K2D clicked-je is azonnal visszatér szam nélkül), és
    // megtekintő módban nem írunk.
    isGeni() {
      return this.store.head.code === "GENI";
    },

    // A GENI projekt-kapcsolat gomb kapuja (K2D w_popup_fokonyv: m_project.visible =
    // gb_project And not gb_purchreq): csak projektkezelésnél (pssyssysfile1.is_project).
    // A gb_purchreq ágat nem vesszük át — a TF-ben nincs beszerzési igénylés, így itt ez az
    // egyetlen út a projekt-kapcsolathoz.
    // ÁTMENETILEG REJTVE (user-döntés, 2026-10-05): a gomb senkinek nem látszik, amíg a
    // projekt-kapcsolat képernyő élesítéséről nincs döntés. Visszakapcsolás: a `false &&` törlése.
    projectButtonVisible() {
      return false && this.isGeni && this.store.flags.projectMenu;
    },

    roundDiffSum() {
      return this.roundDiffs.reduce((sum, r) => sum + (Number(r.roundDiff) || 0), 0);
    },

    // K2D w_response_mix 7-es mód: a pb_acc_date mindig látszik (az ue_acc_date kapu a
    // read-only fejen nem fut). Nálunk is minden MIX-en látszik; a futtathatóságot a
    // mixAccDateDisabledReason dönti el (tiltott gomb + tooltip az okkal).
    mixAccDateVisible() {
      return this.isMix;
    },

    // Miért nem futtatható a könyvelési dátum újragenerálása — üres, ha futtatható.
    // Sorrend: a legalapvetőbb ok elöl.
    mixAccDateDisabledReason() {
      if (this.store.isCreateMode || Number(this.store.head.invNo) <= 1) {
        return t("PreAccounting_ElobbMentseABizonylatot");
      }
      // K2D: a gomb a bizonylat szerkeszthetőségétől függetlenül fut (a már feladott,
      // acc_status=6 eset a fő használati eset — a backend ezt vissza is veszi a
      // főkönyvből, ld. ChangeMixAccDate.cs) — csak a valódi megtekintő nézetet tiltjuk.
      if (this.$route.name === "PreAccView") {
        return t("PreAccounting_MegtekintoNezetbenAKonyvelesiDatumNem");
      }
      // K2D ue_acc_date kapuja + a spp_mix_cont is csak is_acc_date_mod = '+' esetén írja a dátumot
      if (this.store.head.accDateModifiable !== true) {
        return t("PreAccounting_EnnelAMIXTipusnalAKonyvelesi");
      }
      // A spp_mix_cont pontosan egy forrás-bizonylatot vár; enélkül a SP saját hibájára futna
      const storeRefs = [
        this.store.head.storeIn,
        this.store.head.gStoreIn,
        this.store.head.storeOut,
      ].filter((x) => Number(x) > 1).length;
      if (storeRefs !== 1) {
        return this.store.isStockValueDiff
          ? t("PreAccounting_KEKBizonylatonAKonyvelesiDatumA")
          : t("PreAccounting_ABizonylathozNemTartozikBeKitarolas");
      }
      if (this.store.hasChanges) {
        return t("PreAccounting_MentetlenModositasVanElobbMentsen");
      }
      return "";
    },

    // K2D w_response_mix pb_postcalc_price: retrieveend → visible = (stock_value_diff > 1),
    // azaz csak KÉK bizonylaton; nálunk emellett mentett és nem csak-olvasó bizonylat kell
    postcalcPriceVisible() {
      return (
        this.isMix &&
        this.store.isStockValueDiff &&
        Number(this.store.head.invNo) > 1 &&
        !this.store.isCreateMode &&
        !this.store.isReadOnlyView &&
        this.$route.name !== "PreAccView"
      );
    },
    // A számla azonosítása (prefix, számlaszám) a fej-panelen ott van, ezért a
    // címben nem ismételjük meg — csak az üzemmód jelenik meg.
    pageTitle() {
      if (this.$route.name === "PreAccCreate") return t("PreAccounting_SzamlaKontirozasaUjMIXBizonylat");
      if (this.$route.name === "PreAccView") return t("PreAccounting_SzamlaKontirozasaMegtekintes");
      if (!this.store.editable && this.store.head.invNo > 0) return t("PreAccounting_SzamlaKontirozasaCsakOlvashato");
      return t("PreAccounting_SzamlaKontirozasa");
    },

    // K2D d_g_external_tart_kov oszlopai kontír-adatkészlettel; a detailed_type
    // helyét a rendszer-flag adja, a dimcode1-3 az élő dimenziótípusok szerint látszik
    itemColumns() {
      const flags = this.store.flags;
      // K2D: a detailed_type oszlop MINDIG látszik és szerkeszthető — az
      // is_check_det_type csak a HELYÉT dönti el. '+' esetén marad a Könyvelési
      // típus után, egyébként a K2D a szam (ID) mögé, a car elé tolja:
      //   detailed_type.x = szam.x + szam.width - 1
      // (w_popup_fokonyv.srw:2559-2561 Tartozik, 3146-3148 Követel).
      // A TF gridben nincs ID oszlop, így ott a Pénznem után, a CAR elé kerül.
      const detTypeCol = { field: "detailedType", title: t("ReszletezesTipus"), cell: "detailedType", width: "150px" };
      const cols: any[] = [
        { field: "delete", title: " ", cell: "deleteTemplate", width: "100px", sortable: false },
        { field: "accCode", title: t("FokonyviSzam"), cell: "accCode", width: "150px" },
        { field: "accCodeName", title: t("FkSzamNeve"), width: "180px" },
      ];
      // K2D d_g_mixitem: a dim_type nincs a detail bandon (fix 11, pfc_postinsertrow) —
      // MIX-en nem szerkeszthető, ezért az oszlop sincs kirakva
      if (!this.isMix) {
        cols.push({ field: "dimType", title: t("PreAccounting_KonyvelesiTipus"), cell: "dimType", width: "150px" });
      }
      if (flags.checkDetType) {
        cols.push(detTypeCol);
      }
      cols.push({ field: "total", title: t("Osszeg"), cell: "total", width: "130px" });
      for (let i = 1; i <= 3; i++) {
        // K2D: külső főkönyvnél a halott 2/3/4-es dimenziótípus oszlopa rejtett
        if (flags.extBook && flags.dimTypeLive[i + 1] === false) continue;
        cols.push({ field: `dimCode${i}`, title: t("PreAccounting_Dim", [i]), cell: `dimCode${i}`, width: "120px" });
      }
      cols.push(
        { field: "accDate", title: t("KonyvelesDatuma"), cell: "accDate", width: "125px" },
        { field: "note", title: t("Megjegyzes"), cell: "note", width: "200px" },
        { field: "currency", title: t("Penznem"), width: "85px" },
      );
      if (!flags.checkDetType) {
        cols.push(detTypeCol);
      }
      // K2D d_g_mixitem csak-olvasó cikk-oszlopai (open :518-535 feliratai): a tétel
      // készletsorának cikke és cikkcsoportja — csak MIX-en, csak megjelenítés (user-döntés,
      // 2026-09-09; a többi csak-olvasó K2D-oszlop — készlet, periódus, könyvelés ideje,
      // kontír-sablon — tudatosan elhagyva)
      if (this.isMix) {
        cols.push(
          { field: "partsCode", title: t("Cikkszam"), width: "120px" },
          { field: "partsName", title: t("PreAccounting_CikkMegnevezese"), width: "180px" },
          { field: "partGroupCode", title: t("Cikkcsoport"), width: "100px" },
          { field: "partGroupName", title: t("PreAccounting_CikkcsoportMegnevezese"), width: "180px" },
        );
      }
      cols.push(
        { field: "car", title: "CAR", width: "80px", className: "right_text" },
        { field: "prcar", title: "PRCAR", width: "80px", className: "right_text" },
        { field: "project", title: t("Projekt"), width: "80px", className: "right_text" },
        { field: "poId", title: t("Megrendeles"), width: "100px", className: "right_text" },
        // Nincs width megadva: Kendo Grid ezt az oszlopot a maradék szélesség
        // kitöltésére nyújtja — enélkül (pl. "0px"-re rögzítve) egy táblás,
        // teljes szélességű nézetnél üres sáv marad a tábla jobb szélén.
        { sortable: false },
      );
      return cols;
    },

    // Egy táblás nézet: + Tétel típus oszlop (Tartozik/Követel)
    bothColumns() {
      const cols = this.itemColumns.slice(0, -1);
      cols.push({ field: "accSign", title: t("TetelTipus"), cell: "accSign", width: "95px" });
      cols.push({ sortable: false });
      return cols;
    },

    // K2D dw_egyenleg: soronként egy engedélyezett könyvelési típus (a store.bookTypes
    // = a K2D il_filter halmaza), oszloponként a Tartozik ('+') és Követel ('-') összeg.
    // A K2D az összes tételt dim_type-onként összegzi (ue_szamol), majd csak az
    // engedélyezett típusok sorait írja ki — a bookTypes-ra szűkítés ezzel egyenértékű.
    balanceRows() {
      return this.store.bookTypes.map((bt) => {
        let debit = 0;
        let credit = 0;
        this.store.items.forEach((item) => {
          if (item.dimType !== bt.id) return;
          if (item.accSign === "+") {
            debit += Number(item.total) || 0;
          } else {
            credit += Number(item.total) || 0;
          }
        });
        return { id: bt.id, name: bt.name, debit, credit, diff: debit - credit };
      });
    },

    balanceColumns() {
      return [
        // Szűkebb oszlopok: a panel a fejléc mellett fér el (ld. .balance-box)
        { field: "name", title: t("PreAccounting_KonyvelesiTipus"), width: "145px" },
        { field: "debit", title: t("Tartozik"), cell: "debitCell", width: "105px", headerClassName: "right_text" },
        { field: "credit", title: t("Kovetel"), cell: "creditCell", width: "105px", headerClassName: "right_text" },
        { field: "diff", title: t("Denomination_Elteres"), cell: "diffCell", width: "90px", headerClassName: "right_text" },
      ];
    },

    todayString() {
      const now = new Date();
      const m = String(now.getMonth() + 1).padStart(2, "0");
      const d = String(now.getDate()).padStart(2, "0");
      return `${now.getFullYear()}-${m}-${d}`;
    },

    // K2D pfc_preopen: külső főkönyvnél az élő 5..13 típusok szerint; egyébként is_dim_4_9
    dimSectionVisible() {
      const flags = this.store.flags;
      if (flags.extBook) {
        for (let t = 5; t <= 13; t++) {
          if (flags.dimTypeLive[t] !== false) return true;
        }
        return false;
      }
      return flags.dim49;
    },

    // K2D pfc_postopen: pb_felad.visible = gb_book. Új MIX felvitelnél nincs mit feladni.
    postVisible() {
      // MIX-nél nincs feladás-gomb: a K2D MIX-ablakában (w_response_mix) nincs pb_felad
      return (
        this.store.flags.book && !this.store.isCreateMode && !this.isMix && this.store.head.invNo > 0
      );
    },

    // K2D pb_felad: a feladható kontír-státuszok; mentetlen módosítással a K2D is
    // visszafordul („Adatokat változtatott előbb mentsen!")
    postDisabled() {
      return (
        this.store.isItemsLoading ||
        this.isPosting ||
        this.store.hasChanges ||
        ![2, 3, 5, 7, 8, 9].includes(this.store.head.accStatus)
      );
    },

    postTitle() {
      if (this.store.hasChanges) return t("ElobbMentseVagyVesseElA");
      if (![2, 3, 5, 7, 8, 9].includes(this.store.head.accStatus))
        return t("PreAccounting_AKonyvelesAllapotaNemMegfeleloA");
      return t("PreAccounting_AktualisSzamlaFeladasaABelsoFokonyvi");
    },

    // K2D pb_ok: szerkesztő módban a kontír mentése, create módban az új MIX
    // bizonylat felvitele (a K2D-ben is ugyanez az egy gomb)
    // A Mentés melletti piros felkiáltójel szövege — csak szerkeszthető
    // állapotban él, betöltés alatt (félkész adatokon) nem villog
    validationError() {
      if (this.store.isReadOnlyView || this.store.isItemsLoading) return "";
      return this.firstEditError().message;
    },

    saveDisabled() {
      if (this.store.isCreateMode) {
        return (
          Number(this.store.head.invType) <= 1 ||
          this.store.items.length === 0 ||
          this.store.isSaving ||
          this.validationError !== ""
        );
      }
      return (
        this.store.isReadOnlyView ||
        this.store.isItemsLoading ||
        this.store.isSaving ||
        this.validationError !== ""
      );
    },

    saveTitle() {
      if (this.store.isCreateMode) {
        if (Number(this.store.head.invType) <= 1) return t("PreAccounting_ElobbValasszonBizonylatTipust");
        if (this.store.items.length === 0) return t("PreAccounting_VigyenFelLegalabbEgyKontirtetelt");
        return t("PreAccounting_AzUjMIXBizonylatMentese");
      }
      if (this.store.isReadOnlyView) return t("PreAccounting_SzamlaKontirozasaNemModosithato");
      return t("KontirozasMentese");
    },

    // K2D dw_1 retrieveend: pb_cont.of_setenabled(acc_status ∈ {2,5,7,8,9}).
    // MIX-nél a K2D saját ablaka (w_response_mix) MINDIG mutatja a pb_cont gombot —
    // új felvitelnél is ott van, csak mentetlen bizonylaton azonnal visszafordul.
    reAccountVisible() {
      if (this.isMix) return true;
      return !this.store.isCreateMode && this.store.head.invNo > 0;
    },

    reAccountDisabled() {
      return (
        // K2D w_response_mix pb_cont: mentetlen (új) bizonylaton "Előbb mentse el!"
        this.store.isCreateMode ||
        !this.store.reAccountable ||
        this.store.isItemsLoading ||
        this.store.isSaving ||
        this.isReAccounting ||
        // K2D: bármely módosítás mentésig letiltja az auto-kontírt
        this.store.hasChanges
      );
    },

    reAccountTitle() {
      if (this.store.isCreateMode) return t("PreAccounting_ElobbMentseElABizonylatot");
      if (this.store.hasChanges) return t("ElobbMentseVagyVesseElA");
      if (!this.store.reAccountable) return t("PreAccounting_EbbenAKonyvelesiAllapotbanNemKontirozhato");
      return this.isMix
        ? t("PreAccounting_ABizonylatUjrakontirozasaAForrasBizonylatbol")
        : t("PreAccounting_ASzamlaUjrakontirozasaAKorabbiKontirozas");
    },

    // K2D pb_info: a prefix-adatlap csak azoknál a számláknál nyílik, amelyekhez van
    // forrás-bizonylat (GENI = beszerzés, INTR = belső, GARO = garanciális)
    infoVisible() {
      return ["GENI", "INTR", "GARO"].includes(this.store.head.code) && !this.store.isCreateMode;
    },

    // Az adatlap két hasábban áll (a K2D ablakához hasonlóan), hogy ne nyúljon el
    generalFieldsLeft() {
      const fields = this.info.generalFields ?? [];
      return fields.slice(0, Math.ceil(fields.length / 2));
    },

    generalFieldsRight() {
      const fields = this.info.generalFields ?? [];
      return fields.slice(Math.ceil(fields.length / 2));
    },

    // K2D pb_note.visible = (acc_status = 6): a főkönyvi rendszernek feladott számlán a
    // kontírozás már nem módosítható, a megjegyzés viszont igen. MIX-en nincs: a K2D
    // w_response_mix ablakban nincs pb_note, és a mentés (SavePreAccItemNote) a számla-
    // kontírtételre készült.
    noteVisible() {
      return !this.isMix && this.store.head.accStatus === 6 && !this.store.isCreateMode && this.store.head.invNo > 0;
    },

    // A dimenzió-másoló nyilak engedélyezés-feltételei — a gombokkal együtt kivéve
    // (K2D-hűség, ld. a template kommentjét). A kód maradjon:
    // isInSameDimension() {
    //   return this.store.positiveSelectedDimCodeType === this.store.negativeSelectedDimCodeType;
    // },
    //
    // isDisabledToNegative() {
    //   return (
    //     this.store.isReadOnlyView ||
    //     !this.isInSameDimension ||
    //     !this.store.dimensionsRows.includes(this.store.positiveSelectedDimension) ||
    //     !this.store.items.includes(this.store.negativeSelectedItem) ||
    //     this.hasSameItem(this.store.positiveSelectedDimension, this.store.negativeSelectedItem)
    //   );
    // },
    //
    // isDisabledToPositive() {
    //   return (
    //     this.store.isReadOnlyView ||
    //     !this.isInSameDimension ||
    //     !this.store.dimensionsRows.includes(this.store.negativeSelectedDimension) ||
    //     !this.store.items.includes(this.store.positiveSelectedItem) ||
    //     this.hasSameItem(this.store.negativeSelectedDimension, this.store.positiveSelectedItem)
    //   );
    // },
  },

  methods: {
    async loadCurrent() {
      const ref = this.store.currentRef;
      if (!ref) return;
      try {
        await this.store.loadEditorData(ref.code, ref.invNo);
      } catch {
        eventBus.$emit("error", t("PreAccounting_ASzamlaKontirAdataiNemToltodtek"));
        return;
      }
      // Számlánként újra: a tömeges dátumcsere nem szivároghat át a lapozás után
      this.bulkAccDate = "";
      // Az adatlapok is a friss számlához töltődjenek újra
      this.infoLoaded = false;
      this.info = { prefixTitle: "", prefixFields: [], generalFields: [], documents: [] };
      this.logsLoaded = false;
      this.itemLogs = [];
      this.statusLogs = [];
      this.projectLoaded = false;
      this.projectName = "";
      this.roundDiffsLoaded = false;
      this.roundDiffs = [];
      this.store.isReadOnlyView = !(this.$route.name !== "PreAccView" && this.store.editable);
      if (this.store.head.accNoRestricted) {
        // K2D-ben üzenet nélkül lesz minden read-only — itt jelezzük az okot
        eventBus.$emit("warn", t("PreAccounting_ASzamlanOlyanFokonyviSzamSzerepel"));
      }
      this.selectFirstItem();
      // Awaitolva: a mentés/feladás utáni automatikus megnyitás erre a listára épül
      await this.loadErrors();
      // K2D retrieveend: a Kerekítési különbözet gomb láthatósága a mmacc_round_diff
      // sorok lététől függ — MIX-en ezért már betöltéskor lekérjük (nem csak a gombra)
      if (this.isMix && !this.store.isCreateMode) {
        await this.loadRoundDiffs();
      }
    },

    // K2D pb_hiba: az aktuális számla mmaccinvserr sorai. A K2D csak 7/8 kontír
    // státusznál engedi megnyitni; itt — a böngészővel egyezően — a tényleges
    // hibasorok léte dönt, üres listánál a ⚠ gomb tiltott.
    async loadErrors() {
      // Számlaváltásnál/újraolvasásnál ne maradjon nyitva a másik számla listája
      this.errorMenu = false;
      const ref = this.store.currentRef;
      if (this.store.isCreateMode || !ref) {
        this.invoiceErrors = [];
        return;
      }
      try {
        this.invoiceErrors = await PreAccountingApi.getErrors(ref.code, ref.invNo);
      } catch {
        // A hibalista hiánya ne akadályozza a szerkesztést
        this.invoiceErrors = [];
      }
    },

    // K2D pfc_retrieve: fókusz az első Tartozik (ennek híján Követel) sorra
    selectFirstItem() {
      const first =
        this.store.items.find((x) => x.accSign === "+") ??
        this.store.items.find((x) => x.accSign === "-");
      if (first) {
        this.store.selectedItem = first;
      }
    },

    goTo(index: number) {
      if (index < 0 || index >= this.store.invoiceRefs.length) return;
      if (this.store.hasChanges) return;
      this.store.currentIndex = index;
      this.loadCurrent();
    },

    switchTableView() {
      this.isMultiTableView = !this.isMultiTableView;
    },

    // K2D pb_cancel nyomán, de TF-en kérésre egységesen: a Mégse minden módban
    // visszanavigál a hívó böngészőre (számla előkontírozás vagy be/kitárolás),
    // a mentetlen módosítások kérdés nélkül elvesznek (a K2D szerkesztés-módban csak
    // újraolvasott)
    undoChanges() {
      this.store.discardChanges();
      this.$router.push(this.returnPath);
    },

    // K2D pb_insert1/2: új kontírtétel a K2D defaultjaival, negatív temp id-vel.
    // Egy táblás nézetben ('' side) Tartozik sor születik.
    addNewItem(side: string) {
      if (this.store.isReadOnlyView || this.mixItemsLocked) return;
      const sign = side === "positive" ? "-" : "+";
      const sameSide = this.store.items.filter((x) => x.accSign === sign);
      // K2D: id_acc_date (tömeges csere után az új dátum), egyébként az oldal utolsó sora
      const accDate =
        this.bulkAccDate ||
        (sameSide.length > 0
          ? sameSide[sameSide.length - 1].accDate
          : this.store.head.accDate || this.store.head.shipDate || this.store.head.invDate);
      const item: PreAccEditItem = {
        ...PreAccEditItemDefaultProps,
        id: this.store.nextTempId(),
        accSign: sign,
        currency: this.store.head.currency,
        accDate: accDate,
        note: "",
        // K2D dw_tartozik::pfc_postinsertrow — MIX-en fix 11-es könyvelési típus és
        // 23-as részletezés típus, számlán a prefix első engedélyezett típusa
        dimType: this.isMix
          ? 11
          : this.store.bookTypes.length > 0
          ? this.store.bookTypes[0].id
          : 1,
        detailedType: this.isMix ? 23 : this.store.defaultDetailedType,
        period: 1,
        newDimensions: [],
      };
      this.store.items.push(item);
      this.store.newItems.push(item);
      this.store.selectedItem = item;
    },

    // K2D ue_template sormásolás ága: a kijelölt sor duplikálása — a
    // period/curr_total/exchange_rate/car/prcar/project/po_id NEM másolódik
    cloneItem(source: PreAccEditItem, sign: string): PreAccEditItem {
      return {
        ...PreAccEditItemDefaultProps,
        id: this.store.nextTempId(),
        accSign: sign,
        accCode: source.accCode,
        accCodeName: source.accCodeName,
        currency: source.currency,
        accDate: source.accDate,
        note: source.note,
        dimType: source.dimType,
        dimCode1: source.dimCode1,
        dimCode2: source.dimCode2,
        dimCode3: source.dimCode3,
        total: source.total,
        detailedType: source.detailedType,
        period: 1,
        newDimensions: [],
      };
    },

    copyItemFromSelected(item: PreAccEditItem) {
      if (this.store.isReadOnlyView) return;
      if (!item || !this.store.items.includes(item)) return;
      const copy = this.cloneItem(item, item.accSign);
      this.store.items.push(copy);
      this.store.newItems.push(copy);
      this.store.selectedItem = copy;
    },

    // Tétel másolása a bontás-soraival együtt (a bontások új negatív head-re kötve).
    // KIVÉVE (K2D-hűség): a K2D sormásolása a bontás-sorokat nem másolja, mert a
    // bontás összegfüggő, a másolás pedig összeg-átírásra való. A kód maradjon:
    // copyItemFromSelectedWithDimensions(item: PreAccEditItem) {
    //   if (this.store.isReadOnlyView) return;
    //   if (!item || !this.store.items.includes(item)) return;
    //   const copy = this.cloneItem(item, item.accSign);
    //   this.store.items.push(copy);
    //   this.store.newItems.push(copy);
    //
    //   const dims = this.store.dimensionsRows.filter((d) => d.head === item.id);
    //   dims.forEach((d) => {
    //     const dimCopy: PreAccEditDimension = {
    //       ...d,
    //       id: this.store.nextTempId(),
    //       head: copy.id,
    //       inEdit: false,
    //       selected: false,
    //       deleting: false,
    //     };
    //     this.store.dimensionsRows.push(dimCopy);
    //     this.store.newDimensions.push(dimCopy);
    //     copy.newDimensions.push(dimCopy);
    //   });
    //   this.store.selectedItem = copy;
    // },

    removeItem(item: PreAccEditItem) {
      if (this.store.isReadOnlyView || this.mixItemsLocked) return;
      // A tétel bontás-sorai is mennek (K2D pb_delete1: a _d sorok logikai törlése)
      const dims = this.store.dimensionsRows.filter((d) => d.head === item.id);
      dims.forEach((d) => {
        if (d.id > 0) this.store.deletedDimensions.push(d.id);
      });
      this.store.dimensionsRows = this.store.dimensionsRows.filter((d) => d.head !== item.id);
      this.store.newDimensions = this.store.newDimensions.filter((d) => d.head !== item.id);
      this.store.modifiedDimensions = this.store.modifiedDimensions.filter((d) => d.head !== item.id);

      if (item.id > 0) {
        this.store.deletedItems.push(item.id);
      }
      this.store.items = this.store.items.filter((x) => x !== item);
      this.store.newItems = this.store.newItems.filter((x) => x !== item);
      this.store.modifiedItems = this.store.modifiedItems.filter((x) => x.id !== item.id);
    },

    // K2D pb_insert_tart_d/kov_d: új bontás-sor a kijelölt tételhez, total = a tétel összege
    addNewDimension(side: string) {
      if (this.store.isReadOnlyView) return;
      const item = side === "positive" ? this.store.positiveSelectedItem : this.store.negativeSelectedItem;
      if (!item || !this.store.items.includes(item)) {
        eventBus.$emit("warn", t("ElobbJeloljonKiEgyKontirtetelt"));
        return;
      }
      const dimCodeType =
        side === "positive" ? this.store.positiveSelectedDimCodeType : this.store.negativeSelectedDimCodeType;
      const dim: PreAccEditDimension = {
        ...PreAccEditDimensionDefaultProps,
        id: this.store.nextTempId(),
        head: item.id,
        dimCodeType: dimCodeType,
        total: item.total,
      };
      this.store.dimensionsRows.push(dim);
      this.store.newDimensions.push(dim);
      if (item.id <= 0) {
        item.newDimensions.push(dim);
      }
      this.store.selectedDimension = dim;
    },

    removeDimension(dim: PreAccEditDimension) {
      if (this.store.isReadOnlyView) return;
      if (dim.id > 0) {
        this.store.deletedDimensions.push(dim.id);
      }
      this.store.dimensionsRows = this.store.dimensionsRows.filter((x) => x !== dim);
      this.store.newDimensions = this.store.newDimensions.filter((x) => x !== dim);
      this.store.modifiedDimensions = this.store.modifiedDimensions.filter((x) => x.id !== dim.id);
      this.store.items.forEach((it) => {
        it.newDimensions = it.newDimensions.filter((x) => x !== dim);
      });
    },

    // A kijelölt bontás-sor átmásolása a másik oldal kijelölt tételére.
    // KIVÉVE (K2D-hűség): a K2D w_popup_fokonyv dimenzió-blokkjában nincs oldalak
    // közötti másolás, csak insert/delete és a dimenzió-popup. A kód maradjon:
    // copyDimensionFromSelected(side: string) {
    //   if (this.store.isReadOnlyView) return;
    //   const sourceDim = side === "T" ? this.store.positiveSelectedDimension : this.store.negativeSelectedDimension;
    //   const targetItem = side === "T" ? this.store.negativeSelectedItem : this.store.positiveSelectedItem;
    //   if (!this.store.dimensionsRows.includes(sourceDim) || !this.store.items.includes(targetItem)) return;
    //   if (this.hasSameItem(sourceDim, targetItem)) return;
    //   const dim: PreAccEditDimension = {
    //     ...sourceDim,
    //     id: this.store.nextTempId(),
    //     head: targetItem.id,
    //     inEdit: false,
    //     selected: false,
    //     deleting: false,
    //   };
    //   this.store.dimensionsRows.push(dim);
    //   this.store.newDimensions.push(dim);
    //   if (targetItem.id <= 0) {
    //     targetItem.newDimensions.push(dim);
    //   }
    // },
    //
    // Van-e a cél-tételen már ilyen dimenziókódú sor ugyanazon a fülön
    // hasSameItem(dim: PreAccEditDimension, targetItem: PreAccEditItem): boolean {
    //   if (!dim || !targetItem) return false;
    //   return this.store.dimensionsRows.some(
    //     (x) => x.head === targetItem.id && x.dimCodeType === dim.dimCodeType && x.dimCode === dim.dimCode
    //   );
    // },

    onNoteEdit(item: PreAccEditItem) {
      // K2D doubleclicked: read-only gridben a note cellára dupla klikk a
      // Megjegyzés-szerkesztőt nyitja — csak 6-os kontír státuszon
      if (!this.noteVisible || !item) return;
      this.openNoteEditor(item);
    },

    onRegister(refs: any[]) {
      // A tranzakció-szerkesztő hotkey-fókusz regisztrációjának helye — az
      // előkontírozásban a globális Insert/Alt+F12 kezelés fedi (onKeydown)
      void refs;
    },

    columnReorder(columns: any[]) {
      void columns;
    },

    formatMoney(value: number): string {
      return new Intl.NumberFormat("hu-HU", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value ?? 0);
    },

    // K2D cb_acc_date: minden Tartozik és Követel sor könyvelési dátuma egy lépésben
    // (a dim-bontásé és a fejé NEM változik). Utána a lapozó és az auto-kontír a
    // módosítás-jelölés miatt tiltott, amíg nincs mentés/elvetés.
    // K2D pb_acc_date::clicked — a dátumbekérés után f_mix(...) újragenerálás.
    // Minden ellenőrzés (típus-flag, azonos dátum, feladott bizonylat visszavétele)
    // a backendben fut, a K2D üzeneteivel.
    async applyMixAccDate() {
      if (this.store.hasChanges) {
        eventBus.$emit("warn", t("PreAccounting_AdatokatValtoztatottElobbMentsen"));
        return;
      }
      const ref = this.store.currentRef;
      if (!ref) return;
      if (!this.mixAccDateValue) {
        eventBus.$emit("warn", t("PreAccounting_AdjonMegKonyvelesiDatumot"));
        return;
      }

      this.mixAccDateMenu = false;
      this.isRegeneratingMix = true;
      try {
        const result = await PreAccountingApi.changeMixAccDate(
          ref.code,
          ref.invNo,
          this.mixAccDateValue
        );
        eventBus.$emit(
          "success",
          t("PreAccounting_ABizonylatUjrageneralvaKonyvelesiDatumraKonyvele", [result.accDate, result.accStatusName])
        );
        // Az f_spp_mix_cont a fej azonosítóját adja vissza; ha változott, oda kell lépni
        if (Number(result.invNo) > 1 && Number(result.invNo) !== Number(ref.invNo)) {
          this.$router.push({
            path: `/pre-accounting/${ref.code}/${result.invNo}/edit`,
            query: this.$route.query,
          });
          return;
        }
        await this.loadCurrent();
      } catch {
        // A backend K2D-üzenetét a globális hibakezelő már megjelenítette
      } finally {
        this.isRegeneratingMix = false;
      }
    },

    // K2D pb_postcalc_price::clicked: cikk/periódus ellenőrzés, "Már módosítva lett az
    // utókalkulációs ár!" kérdés, f_spp_stock_postcalc_price(period, parts). Az ellenőrzések
    // és a kérdés a backendben dőlnek el (needsConfirmation); a kérdésre Igen = confirmed hívás.
    async recalcPostcalcPrice(confirmed: boolean) {
      if (this.store.hasChanges) {
        eventBus.$emit("warn", t("PreAccounting_AdatokatValtoztatottElobbMentsen"));
        return;
      }
      const ref = this.store.currentRef;
      if (!ref) return;

      this.postcalcConfirmVisible = false;
      this.isRecalcPostcalc = true;
      try {
        const result = await PreAccountingApi.recalcMixPostcalcPrice(ref.code, ref.invNo, confirmed);
        if (result.needsConfirmation) {
          this.postcalcConfirmMessage = result.confirmMessage;
          this.postcalcConfirmVisible = true;
          return;
        }
        eventBus.$emit(
          "success",
          t("PreAccounting_AzUtokalkulaciosArUjraszamolasaLefutottA")
        );
      } catch {
        // A backend K2D-üzenetét a globális hibakezelő már megjelenítette
      } finally {
        this.isRecalcPostcalc = false;
      }
    },

    applyAccDate() {
      if (this.store.isReadOnlyView) return;
      const date = this.accDateValue;
      if (!date) {
        eventBus.$emit("warn", t("PreAccounting_AdjonMegKonyvelesiDatumot"));
        return;
      }
      // K2D dp_acc_date: kemény tiltás (a naptár maxa is ma, ez a védőháló)
      if (date > this.todayString) {
        eventBus.$emit("warn", t("OverSummary_NemAdhatMegJovobeliDatumot"));
        return;
      }
      this.store.items.forEach((item) => {
        if (String(item.accDate).split("T")[0] === date) return;
        item.accDate = date;
        if (item.id > 0 && !this.store.modifiedItems.some((x) => x.id === item.id)) {
          this.store.modifiedItems.push(item);
        }
      });
      // K2D id_acc_date: az ezután felvitt sorok is az új dátumot kapják
      this.bulkAccDate = date;
      this.accDateMenu = false;
    },

    // K2D pb_felad: az aktuális számla feladása a belső főkönyvi rendszerbe.
    // Az ellenőrzések (nyitott periódus, kötelező kontírok, ÁFA-lezártság, kötelező
    // dimenziókódok, státusz-kapuk) mind a backendben futnak — a K2D üzeneteivel.
    // A K2D a periódus-kérdést a folyamat közepén teszi fel, ezért két hívás:
    // confirmed=false → csak ellenőrzés + kérdés, confirmed=true → feladás.
    async postToLedger(confirmed: boolean) {
      if (this.store.hasChanges) {
        eventBus.$emit("warn", t("PreAccounting_AdatokatValtoztatottElobbMentsen"));
        return;
      }
      const ref = this.store.currentRef;
      if (!ref) return;

      this.postConfirmVisible = false;
      this.isPosting = true;
      try {
        const result = await PreAccountingApi.postInvoice(
          ref.code,
          ref.invNo,
          confirmed,
          this.store.originalAccStatus
        );

        if (result.needsConfirmation) {
          this.postConfirmMessage = result.confirmMessage;
          this.postConfirmVisible = true;
          return;
        }

        if (result.posted) {
          eventBus.$emit("success", t("PreAccounting_ASzamlaFeladvaKonyvelesAllapot", [result.accStatusName]));
          if (result.warning) eventBus.$emit("warn", result.warning);
          // K2D: 7/8-as státusznál magától felnyílik a hibalista — a loadCurrent
          // már friss mmaccinvserr listát hozott, csak ki kell nyitni a menüt
          await this.loadCurrent();
          if (this.invoiceErrors.length > 0) this.errorMenu = true;
        }
      } catch {
        // A backend K2D-üzenetét a globális hibakezelő már megjelenítette
      } finally {
        this.isPosting = false;
      }
    },

    // K2D pfc_accepttext + itemchanged: minden soron kötelező a főkönyvi szám, és az
    // összeg nem lehet üres/nulla. Üres string = az első hibás sor kijelölve, üzenettel.
    // Az első hibás tétel + hibaüzenet, mellékhatás nélkül — a Mentés melletti
    // hibajelző (validationError computed) és a mentés is ezt használja.
    firstEditError(): { message: string; item: PreAccEditItem | null } {
      for (const item of this.store.items) {
        const side = item.accSign === "+" ? "Tartozik" : t("Kovetel");
        if (!item.accCode || String(item.accCode).trim() === "") {
          return { message: t("PreAccounting_OldalonVanFokonyviSzamNelkuliTetel", [side]), item };
        }
        // K2D w_response_mix dw_tartozik/dw_kovetel::itemchanged: MIX tételen total <= 0 →
        // "Csak pozitív értékeket adjon meg!" (a negatív is tiltott, nem csak a nulla)
        if (this.isMix && !(Number(item.total) > 0)) {
          return { message: t("PreAccounting_CsakPozitivErtekeketAdjonMegA", [item.accCode, side]), item };
        }
        if (!Number(item.total)) {
          return { message: t("PreAccounting_AZFokonyviSzamuTetelOsszege", [item.accCode, side]), item };
        }
        if (!item.accDate || String(item.accDate).trim() === "") {
          return { message: t("PreAccounting_AZFokonyviSzamuTetelnekNincs", [item.accCode, side]), item };
        }
      }
      // A bontás-soroknak dimenziókód nélkül nincs értelme (DLMP471-minta)
      for (const dim of this.store.dimensionsRows) {
        if (!dim.dimCode || String(dim.dimCode).trim() === "") {
          return { message: t("VanDimenziokodNelkuliBontasSorA"), item: null };
        }
      }
      return { message: "", item: null };
    },

    validateItems(): string {
      const err = this.firstEditError();
      if (err.item) this.store.selectedItem = err.item;
      return err.message;
    },

    // K2D pb_ok: mentés után NEM zárunk be, csak újraolvasunk
    async save() {
      if (this.saveDisabled) return;

      const error = this.validateItems();
      if (error) {
        eventBus.$emit("warn", error);
        return;
      }

      // Új MIX bizonylat: a fej is most jön létre, utána a mentett bizonylatra lépünk
      if (this.store.isCreateMode) {
        try {
          const created = await this.store.createMix();
          eventBus.$emit(
            "success",
            t("PreAccounting_AzUjMIXBizonylatElmentveMIX", [created.invNo, created.accStatusName])
          );
          // A fej is mentve — a snapshotot is szinkronizáljuk, különben a kézzel
          // választott költséghely miatt a beforeRouteLeave még rákérdezne
          this.store.markSaved();
          this.$router.push(`/pre-accounting/MIX/${created.invNo}/edit`);
        } catch {
          // A backend K2D-üzenetét a globális hibakezelő már megjelenítette
        }
        return;
      }

      try {
        const result = await this.store.save();
        eventBus.$emit(
          "success",
          result.statusChanged
            ? t("AKontirozasMentveKonyvelesAllapot", [result.accStatusName])
            : t("AKontirozasMentve")
        );
        // A validáció hibái (8-as státusz) — a K2D hibalistájának megfelelően
        const hasErrors = (result.errors ?? []).length > 0;
        await this.loadCurrent();
        if (hasErrors) {
          eventBus.$emit("warn", t("AKontirozasHibasNezzeMegA"));
          this.errorMenu = this.invoiceErrors.length > 0;
        }
      } catch {
        // A backend K2D-üzenetét a globális hibakezelő már megjelenítette
      }
    },

    // K2D pb_cont: 5-ös és 7-es státusznál előbb megerősítés
    // K2D dw_1::buttonclicked: a bontás mentése után rákérdez az újrakontírozásra.
    // (A K2D-ben a „nem kontírozható" ág elérhetetlen kód — nálunk figyelmeztetés.)
    onAccGroupSplitSaved() {
      eventBus.$emit("success", t("PreAccounting_AKoltseghelyBontasMentve"));
      if (this.reAccountDisabled) {
        eventBus.$emit(
          "warn",
          t("PreAccounting_ValtoztatottASzamlaKoltseghelyBontasanAhhoz_2")
        );
        return;
      }
      this.splitReAccountConfirmVisible = true;
    },

    startReAccount() {
      if (this.reAccountDisabled) return;
      // K2D: a megerősítő kérdés a számla-ablak (f_kontiroz) sajátja — a MIX
      // pb_cont-ja (w_response_mix) kérdés nélkül újrakontíroz
      if (!this.isMix && (this.store.head.accStatus === 5 || this.store.head.accStatus === 7)) {
        this.reAccountConfirmVisible = true;
        return;
      }
      this.doReAccount();
    },

    async doReAccount() {
      this.reAccountConfirmVisible = false;
      this.isReAccounting = true;
      try {
        const result = await this.store.reAccount();
        eventBus.$emit("success", t("PreAccounting_AutomatikusKontirozasMegtortentKonyvelesAllapot", [result.accStatusName]));
        await this.loadCurrent();
        if (this.invoiceErrors.length > 0) this.errorMenu = true;
      } catch {
        // A backend K2D-üzenetét a globális hibakezelő már megjelenítette
      } finally {
        this.isReAccounting = false;
      }
    },

    // K2D pb_info / pb_info2: az adatlapok a gomb megnyitásakor töltődnek (egy hívás
    // mindkettőt kiszolgálja, számlánként egyszer)
    // K2D ue_doksik → w_popup_genidoc_os: a csatolt dokumentum megnyitása.
    // A kiszolgáló a bejövő számla modul MEGLÉVŐ végpontja (general-incoming-invoice/file),
    // ami a dokumentum-könyvtárból (SysFile2.DocDir/GENI) adja ki a fájlt — a lista és a
    // végpont ugyanabból az iminigeninv_pict táblából dolgozik.
    documentUrl(doc: PreAccInvoiceDoc): string {
      return GeneralIngoingInvoiceApi.generateFileDownLoadLink(doc.id);
    },

    // K2D cb_round_diff → w_round_diff: csak olvasás, bizonylatonként egyszer töltve
    async loadRoundDiffs() {
      const ref = this.store.currentRef;
      if (!ref || this.roundDiffsLoaded || this.isRoundDiffsLoading) return;
      this.isRoundDiffsLoading = true;
      try {
        this.roundDiffs = await PreAccountingApi.getRoundDiffs(ref.code, ref.invNo);
      } catch {
        this.roundDiffs = [];
      } finally {
        this.roundDiffsLoaded = true;
        this.isRoundDiffsLoading = false;
      }
    },

    // A különbözet tört fillér is lehet (round(x,2)-x), ezért 2-10 tizedest mutatunk
    formatRoundDiff(value: number): string {
      return new Intl.NumberFormat("hu-HU", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 10,
      }).format(value ?? 0);
    },

    // K2D w_popup_vat_date_os pfc_preopen: az ablak az aktuális ÁFA dátummal és az
    // előzetes figyelmeztetésekkel nyílik; a látott dátumot a mentés visszaküldi
    // ("időközben módosult" ellenőrzés)
    async loadVatDateInfo() {
      const ref = this.store.currentRef;
      if (!ref) return;
      this.isVatDateInfoLoading = true;
      this.vatDateInfo = null;
      this.vatDateValue = "";
      try {
        this.vatDateInfo = await PreAccountingApi.getGeniVatDateInfo(ref.invNo);
        this.vatDateValue = this.vatDateInfo.vatDate;
      } catch {
        // A backend üzenetét a globális hibakezelő már megjelenítette
      } finally {
        this.isVatDateInfoLoading = false;
      }
    },

    // K2D w_popup_vat_date_os pb_ok: a guard-lánc a backendben fut; a lezárt ÁFA időszak
    // YesNo-kérdése needsConfirmation-ként jön vissza, megerősítés után újra küldjük
    async applyVatDate(confirmClosedPeriod: boolean) {
      const ref = this.store.currentRef;
      if (!ref) return;
      if (!this.vatDateValue) {
        eventBus.$emit("warn", t("PreAccounting_AdjonMegAFADatumot"));
        return;
      }
      this.isSavingVatDate = true;
      try {
        const result = await PreAccountingApi.setGeniVatDate(
          ref.invNo,
          this.vatDateValue,
          this.vatDateInfo ? this.vatDateInfo.vatDate : "",
          confirmClosedPeriod
        );
        if (result.needsConfirmation) {
          this.vatDateConfirmMessage = result.confirmMessage;
          this.vatDateConfirmVisible = true;
          return;
        }
        if (!result.changed) {
          // K2D: 'Az adatbázisban is ugyanez az ÁFA dátum van tárolva!'
          eventBus.$emit("warn", result.messages[0] ?? t("PreAccounting_AzAFADatumNemValtozott"));
          return;
        }
        this.vatDateMenu = false;
        for (const m of result.messages) {
          eventBus.$emit(m.startsWith("A módosítás megtörtént") ? "success" : "warn", m);
        }
        // az adatlapok a friss dátumot mutassák
        this.infoLoaded = false;
        this.info = { prefixTitle: "", prefixFields: [], generalFields: [], documents: [] };
        if (result.needsReaccount && !this.reAccountDisabled) {
          this.vatDateReAccountConfirmVisible = true;
        }
      } catch (e) {
        // K2D: 'Időközben módosult a számla ÁFA dátum, így újraolvasom az adatbázisból!'
        // — a globális hibakezelő kiírta (handleApiResponse "Server error: …" szöveggel
        // utasít el), mi újratöltjük az ablakot
        if (String(e ?? "").includes("Időközben módosult")) await this.loadVatDateInfo();
      } finally {
        this.isSavingVatDate = false;
      }
    },

    // K2D ue_menu_project: TF-ben a kapcsolat megjelenik, a szerkesztés a bejövő
    // számla oldalán marad (meglévő funkció, nem duplikáljuk)
    async loadProject() {
      const ref = this.store.currentRef;
      if (!ref || this.projectLoaded || this.isProjectLoading) return;
      this.isProjectLoading = true;
      try {
        const data = await GeneralIngoingInvoiceApi.getProjectData(ref.invNo);
        const head = (data as any)?.selectedProjectHead;
        this.projectName = head && head.id > 1 ? `${head.name} (${head.id})` : "";
      } catch {
        this.projectName = "";
      } finally {
        this.projectLoaded = true;
        this.isProjectLoading = false;
      }
    },

    openProjectsPage() {
      const ref = this.store.currentRef;
      if (!ref) return;
      this.projectMenu = false;
      this.$router.push(`/pre-accounting/GENI/${ref.invNo}/projects`);
    },

    // K2D ue_naplo + ue_accstat_naplo: a két napló egyszerre töltődik, számlánként
    // egyszer (lapozáskor nullázódik, mint az adatlapok)
    async loadLogs() {
      const ref = this.store.currentRef;
      if (!ref || this.logsLoaded || this.isLogsLoading) return;
      this.isLogsLoading = true;
      try {
        const [items, statuses] = await Promise.all([
          PreAccountingApi.getItemLog(ref.code, ref.invNo),
          PreAccountingApi.getStatusLog(ref.code, ref.invNo),
        ]);
        this.itemLogs = items;
        this.statusLogs = statuses;
      } catch {
        this.itemLogs = [];
        this.statusLogs = [];
      } finally {
        this.logsLoaded = true;
        this.isLogsLoading = false;
      }
    },

    // A napló a nyers oszlopnevet tárolja (K2D-kompatibilis llaccaccitem sorok) —
    // a felületen a képernyő magyar feliratait mutatjuk
    logFieldLabel(field: string): string {
      const labels: Record<string, string> = {
        "acc_code": t("FokonyviSzam"),
        "acc_date": t("KonyvelesDatuma"),
        "total": t("Osszeg"),
        "note": t("Megjegyzes"),
        "dim_type": t("PreAccounting_KonyvelesiTipus"),
        "detailed_type": t("ReszletezesTipus"),
        "dimcode1": "Dim 1",
        "dimcode2": "Dim 2",
        "dimcode3": "Dim 3",
        "currency": t("Penznem"),
      };
      return labels[(field ?? "").trim()] ?? field;
    },

    async loadInfo() {
      const ref = this.store.currentRef;
      if (!ref || this.infoLoaded) return;
      try {
        this.info = await PreAccountingApi.getInvoiceInfo(ref.code, ref.invNo);
      } catch {
        this.info = { prefixTitle: "", prefixFields: [], generalFields: [], documents: [] };
      } finally {
        this.infoLoaded = true;
      }
    },

    // K2D pb_note: a kijelölt kontírtétel megjegyzése (a legutóbb fókuszált oldalról),
    // illetve a note-cellán dupla klikkel a kattintott tétel
    openNoteEditor(item: PreAccEditItem | null) {
      const target = item && this.store.items.includes(item) ? item : this.store.selectedItem;
      if (!target || !this.store.items.includes(target)) {
        eventBus.$emit("warn", t("ElobbJeloljonKiEgyKontirtetelt"));
        this.noteMenu = false;
        return;
      }
      this.noteItem = target;
      this.noteText = target.note ?? "";
      this.noteMenu = true;
    },

    async saveNote() {
      if (!this.noteItem) return;
      this.isSavingNote = true;
      try {
        await this.store.saveItemNote(this.noteItem, this.noteText);
        eventBus.$emit("success", t("PreAccounting_AMegjegyzesMentveAFokonyviTetelen"));
        this.noteMenu = false;
      } catch {
        // A backend K2D-üzenetét a globális hibakezelő már megjelenítette
      } finally {
        this.isSavingNote = false;
      }
    },

    // K2D hotkey-k: Insert = új sor az aktív oldalon, Alt+F12 = a másik oldal első sora.
    // A K2D-ben ez sima F12 (dw_tartozik::ue_keyf3 → KeyF12! → dw_kovetel.setfocus()),
    // böngészőben viszont az F12 a DevTools-é — ezért Alt+F12-re tettük.
    onKeydown(e: KeyboardEvent) {
      if (this.store.isReadOnlyView) return;
      const target = e.target as HTMLElement;
      if (e.key === "Insert" && !(target && (target.tagName === "INPUT" || target.tagName === "TEXTAREA"))) {
        const side = this.store.selectedItem.accSign === "-" ? "positive" : "negative";
        this.addNewItem(side);
        e.preventDefault();
      }
      if (e.key === "F12" && e.altKey) {
        const otherSign = this.store.selectedItem.accSign === "+" ? "-" : "+";
        const other = this.store.items.find((x) => x.accSign === otherSign);
        if (other) this.store.selectedItem = other;
        e.preventDefault();
      }
    },
  },

  watch: {
    // A K2D a dátum-ablakot a számla aktuális kontír-dátumával nyitja (id_acc_date)
    accDateMenu(open: boolean) {
      if (!open) return;
      const first = this.store.items[0];
      const current =
        this.bulkAccDate ||
        (first ? String(first.accDate).split("T")[0] : "") ||
        String(
          this.store.head.accDate || this.store.head.shipDate || this.store.head.invDate || ""
        ).split("T")[0];
      // A naptár maxa ma, ezért a jövőbeli fej-dátumot nem adhatjuk kezdőértéknek
      this.accDateValue = current && current > this.todayString ? this.todayString : current;
    },

    // K2D pfc_preopen: az ÁFA dátum ablak az aktuális dátummal és a figyelmeztetésekkel nyílik
    vatDateMenu(open: boolean) {
      if (open) this.loadVatDateInfo();
    },

    // K2D: a dátum-ablak a bizonylat aktuális könyvelési dátumával nyílik
    mixAccDateMenu(open: boolean) {
      if (!open) return;
      const current = String(this.store.head.accDate || "").split("T")[0];
      this.mixAccDateValue = current && current > this.todayString ? this.todayString : current;
    },
  },
});
